module.exports = __webpack_public_path__ + "img/unlock.4488f459.svg";